$(function() {

	$('.duplicate-survey').click(function() {

		if (!confirm('Duplicate this survey?')) {
			return false;
		}

	});

});